import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminGoogleWorkspace = lazy(() => import("@/pages/admin/AdminGoogleWorkspace"));

export const Route = createFileRoute("/admin/integrationer/google-workspace")({
  head: () => ({ meta: [{ title: "Google Workspace – Adminpanel" }] }),
  component: () => <AdminGoogleWorkspace />,
});
